<template>
    <section class="partners">
        <div class="wrap">
            <div class="headline">
                <div class="kicker">07 / TECHNOLOGY ECOSYSTEM</div>

                <h2>
                    Works with<br>
                    <em>your stack.</em>
                </h2>

                <p>
                    UniteCore brings together the disciplines that modern technology environments depend on.
                </p>
            </div>

            <div class="ecosystem">
                <div v-for="(p, i) in partners" :key="p.name + i" class="eco">
                    <span>{{ String(i + 1).padStart(2, '0') }}</span>

                    <div class="partner-logo">
                        <img :src="publicAsset(p.logo)" :alt="p.name">
                    </div>

                    <b>{{ p.name }}</b>
                    <small>{{ p.text }}</small>
                </div>
            </div>
        </div>

        <div class="ticker">
            <span v-for="n in 3" :key="n">
                CLOUD • SECURITY • NETWORKS • DATA • ANALYTICS • INFRASTRUCTURE •
            </span>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TechnologyPartners',

    data() {
        return {
            partners: [
                {
                    name: 'Palo Alto',
                    text: 'Cyber Security',
                    logo: 'assets/download-Photoroom (14).png'
                },
                {
                    name: 'Palo Alto',
                    text: 'Security',
                    logo: 'assets/images-Photoroom.png'
                },
                {
                    name: 'Motadata',
                    text: 'IT Operations',
                    logo: 'assets/download-Photoroom (4).png'
                },
                {
                    name: 'IBM',
                    text: 'Technology',
                    logo: 'assets/download-Photoroom (5).png'
                },
                {
                    name: 'Fortinet',
                    text: 'Network Security',
                    logo: 'assets/download-Photoroom (6).png'
                },
                {
                    name: 'Hitachi',
                    text: 'Infrastructure',
                    logo: 'assets/download-Photoroom (7).png'
                },
                {
                    name: 'SOTI MobiControl',
                    text: 'Device Management',
                    logo: 'assets/download-Photoroom (8).png'
                },
                {
                    name: 'Thales',
                    text: 'Data Security',
                    logo: 'assets/thales.png'
                },
                {
                    name: 'VMware',
                    text: 'Virtualization',
                    logo: 'assets/download-Photoroom (10).png'
                },
                {
                    name: 'Accops',
                    text: 'Digital Workspace',
                    logo: 'assets/induscafe.png'
                },
                {
                    name: 'Infoblox',
                    text: 'Network Services',
                    logo: 'assets/download-Photoroom (13).png'
                },
                {
                    name: 'CrowdStrike',
                    text: 'Cyber Security',
                    logo: 'assets/crowdstrike.png'
                },
                {
                    name: 'Seclore',
                    text: 'Data Security',
                    logo: 'assets/seclore.png'
                },
                {
                    name: 'ForeScout',
                    text: 'Network Security',
                    logo: 'assets/download-Photoroom (16).png'
                },
                {
                    name: 'MobiControl',
                    text: 'Mobility',
                    logo: 'assets/mobicontrol.png'
                },
                {
                    name: 'OpenText',
                    text: 'Information Management',
                    logo: 'assets/Opentext_logo.png'
                },
                {
                    name: 'ForeScout',
                    text: 'Security',
                    logo: 'assets/forscout.png'
                },
                {
                    name: 'DNIF',
                    text: 'Security Analytics',
                    logo: 'assets/DNIF_logo.png'
                },
                {
                    name: 'Cato',
                    text: 'Network Security',
                    logo: 'assets/cato.png'
                },
                {
                    name: 'Netskope',
                    text: 'Cloud Security',
                    logo: 'assets/netskope.png'
                }
            ]
        };
    },

    methods: {
        publicAsset(fileName) {
            const baseUrl = process.env.BASE_URL || "/";
            const cleanFileName = String(fileName).replace(/^\/+/, "");
            return `${baseUrl}${cleanFileName}`;
        }
    }
};
</script>

<style scoped>
.partners {
    background: #f7f7f4;
    padding: 120px 0 0;
    overflow: hidden;
}

/* MAIN SECTION */
.wrap {
    width: min(1220px, calc(100% - 42px));
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 65px;
}

/* HEADING */
.headline {
    width: 100%;
}

.kicker {
    color: #f5820b;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: .15em;
}

.headline h2 {
    font: 700 clamp(46px, 5vw, 70px)/.95 'Space Grotesk';
    letter-spacing: -.055em;
    margin: 22px 0;
}

.headline h2 em {
    font-style: normal;
    color: #f5820b;
}

.headline p {
    color: #333835;
    line-height: 1.8;
    max-width: 600px;
    margin: 0;
}

/* TECHNOLOGY PARTNER LOGOS */
.ecosystem {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background: #ffffff;
    border: 1px solid #dededb;
}

/* EACH LOGO */
.eco {
    position: relative;
    width: 20%;
    height: 125px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    border-right: 1px solid #e4e4e1;
    border-bottom: 1px solid #e4e4e1;
    transition: background .25s ease, transform .25s ease;
}

/* Every 5th item = end of row */
.eco:nth-child(5n) {
    border-right: 0;
}

/* Last 5 items */
.eco:nth-last-child(-n + 5) {
    border-bottom: 0;
}

/* NUMBER HIDDEN */
.eco>span {
    display: none;
}

/* LOGO */
.partner-logo {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.partner-logo img {
    display: block;
    width: auto;
    height: auto;
    max-width: 155px;
    max-height: 55px;
    object-fit: contain;
    filter: grayscale(100%);
    opacity: .75;
    transition: filter .3s ease, opacity .3s ease, transform .3s ease;
}

/* HIDE TEXT UNDER LOGOS */
.eco b,
.eco small {
    display: none;
}

/* HOVER */
.eco:hover {
    background: #123c35;
    transform: translateY(-3px);
    z-index: 2;
    box-shadow: 0 12px 30px rgba(0, 0, 0, .08);
}

.eco:hover .partner-logo img {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.06);
}

/* TICKER */
.ticker {
    margin-top: 90px;
    width: 100%;
    background: #111315;
    color: #f5820b;
    white-space: nowrap;
    overflow: hidden;
    padding: 16px 0;
    font: 700 13px Inter, sans-serif;
    letter-spacing: .15em;
}

.ticker span {
    display: inline-block;
    margin-right: 50px;
}

/* TABLET */
@media (max-width: 1000px) {
    .partners {
        padding-top: 100px;
    }

    .wrap {
        width: min(900px, calc(100% - 36px));
        gap: 55px;
    }

    .eco {
        width: 25%;
        height: 115px;
    }

    /* 4 columns */
    .eco:nth-child(5n) {
        border-right: 1px solid #e4e4e1;
    }

    .eco:nth-child(4n) {
        border-right: 0;
    }

    .eco:nth-last-child(-n + 5) {
        border-bottom: 1px solid #e4e4e1;
    }

    .eco:nth-last-child(-n + 4) {
        border-bottom: 0;
    }

    .partner-logo img {
        max-width: 135px;
        max-height: 48px;
    }
}

/* MOBILE */
@media (max-width: 700px) {
    .partners {
        padding: 85px 0 0;
    }

    .wrap {
        width: calc(100% - 30px);
        gap: 42px;
    }

    .headline h2 {
        font-size: clamp(42px, 12vw, 58px);
    }

    .headline p {
        max-width: 100%;
        font-size: 14px;
    }

    .ecosystem {
        width: 100%;
    }

    .eco {
        width: 50%;
        height: 105px;
        padding: 12px;
    }

    /* 2 columns */
    .eco:nth-child(4n),
    .eco:nth-child(5n) {
        border-right: 1px solid #e4e4e1;
    }

    .eco:nth-child(2n) {
        border-right: 0;
    }

    .eco:nth-last-child(-n + 4) {
        border-bottom: 1px solid #e4e4e1;
    }

    .eco:nth-last-child(-n + 2) {
        border-bottom: 0;
    }

    .partner-logo {
        height: 55px;
    }

    .partner-logo img {
        max-width: 110px;
        max-height: 40px;
    }

    .ticker {
        margin-top: 60px;
    }
}

/* SMALL MOBILE */
@media (max-width: 420px) {
    .wrap {
        width: calc(100% - 24px);
    }

    .headline h2 {
        font-size: 42px;
    }

    .eco {
        height: 90px;
        padding: 8px;
    }

    .partner-logo {
        height: 48px;
    }

    .partner-logo img {
        max-width: 92px;
        max-height: 34px;
    }
}
</style>